import styled from 'styled-components';
import colors from '../../styles/theme/colors';
import spaces from '../../styles/theme/spaces';

const StepsRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${spaces.micro};
  width: 100%;
  max-width: 256px;
  margin-bottom: ${spaces.xs};
  margin: auto;
`;

const Step = styled.div`
  display: flex;
  align-items: center;
  gap: ${spaces.micro};
`;

const StepCircle = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  aspect-ratio: 1/1;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  border: 1.5px solid ${colors.gray[100]};
  background: ${colors.default.white};
  font-size: 16px;
  font-weight: 600;
  color: ${colors.gray[300]};
  line-height: 1.5;
  font-family: 'Poppins', sans-serif;
  
  &.active {
    color: ${colors.default.white};
    border: 2px solid ${colors.primary.main};
    background: ${colors.primary.main};
  }

  &.completed {
    background: ${colors.default.white};
    border: 1px solid ${colors.green[500]};
    color: ${colors.green[500]};
  }
`;

const StepLabel = styled.h2`
  font-size: 14px;
  color: ${colors.gray[400]};
  font-weight: 500;
  line-height: 1.4;
  font-family: 'Poppins', sans-serif;

  &.active {
    color: ${colors.primary.main};
  }

  &.completed {
    color: ${colors.gray[700]};
  }
`;

const StepConnector = styled.div`
  width: 100%;
  min-width: 40px;
  height: 1.5px;
  background: ${colors.gray[100]};

  &.completed {
    background: ${colors.green[500]};
  }
`;

export { StepsRow, Step, StepCircle, StepLabel, StepConnector };